import { PixKeyClaim } from "./key-claim.model";
import { PixKeyType } from "./key-type.enum";

export class PixKeyClaimView {
	key: string;
	type: PixKeyType;
	createDate: Date;
	institution: string;
	name: string;
	others: any;

	constructor(claim: PixKeyClaim) {
		this.key = '';
		this.key = '';
		this.key = '';
		this.key = '';
		this.key = '';
		this.key = '';
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/key-claim-view.model.ts